import type { ISkipMarker } from '@dicetechnology/dice-unity/lib/types/content';
import { SkipMarkerMode } from '@dicetechnology/dice-unity/lib/types/content';
import { clip } from '@dicetechnology/doris-core';

import type { SkipMarker } from '../types';

export function mapSkipMarker(marker: ISkipMarker): SkipMarker {
    const { skipMarkerType, startTimeMs, stopTimeMs, mode, title, titleLocalisations } = marker;
    const skipMarker: SkipMarker = {
        type: skipMarkerType,
        start: clip(startTimeMs / 1000),
        end: clip(stopTimeMs / 1000)
    };

    if (mode && mode != SkipMarkerMode.STANDARD) {
        skipMarker.mode = mode;
    }
    if (title) {
        skipMarker.title = title;
    }
    if (titleLocalisations && titleLocalisations.length > 0) {
        skipMarker.titleLocalisations = titleLocalisations;
    }

    return skipMarker;
}
